// Third Party Imports
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import classNames from 'classnames';

// Artifactory Imports
import {ButtonIconOverlay} from '@homeaway/react-buttons';
import {CHEVRON_LEFT__16} from '@homeaway/svg-defs';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';

const CarouselButtonsDesktop = ({
    handlePrev,
    handleNext,
    reduceButtonHitTarget = false,
}) => {
    const navPrevArrowWrapperClasses = classNames(
        'carousel-desktop__nav-wrapper carousel-desktop__nav-wrapper--prev',
        {
            'carousel-desktop__nav-wrapper--reduced': reduceButtonHitTarget,
        }
    );
    const navNextArrowWrapperClasses = classNames(
        'carousel-desktop__nav-wrapper carousel-desktop__nav-wrapper--next',
        {
            'carousel-desktop__nav-wrapper--reduced': reduceButtonHitTarget,
        }
    );

    return (
        <Fragment>
            <div
                className={navPrevArrowWrapperClasses}
                key="carousel__nav-wrapper-0"
            >
                <ButtonIconOverlay
                    className="carousel-desktop__nav carousel-desktop__nav--prev"
                    aria-label="Previous"
                    onClick={handlePrev}
                    circle
                    label=""
                    svgMarkup={CHEVRON_LEFT__16}
                />
            </div>
            <div
                className={navNextArrowWrapperClasses}
                key="carousel__nav-wrapper-1"
            >
                <ButtonIconOverlay
                    className="carousel-desktop__nav carousel-desktop__nav--next"
                    aria-label="Next"
                    onClick={handleNext}
                    circle
                    label=""
                    svgMarkup={CHEVRON_RIGHT__16}
                />
            </div>
        </Fragment>
    );
};

CarouselButtonsDesktop.propTypes = {
    handlePrev: PropTypes.func.isRequired,
    handleNext: PropTypes.func.isRequired,
};

export default CarouselButtonsDesktop;
